module.exports = PRSS;